import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/LanguageContext';
import { Construction } from 'lucide-react';

const TEXT = {
  he: {
    title: 'האתר עדיין בבנייה',
    body: 'מנגנון הזמנת ההרצאות אינו מוכן עדיין. נשמח שתחזרו בקרוב — בינתיים ניתן ליצור קשר ישירות במייל amirassi@ono.ac.il',
    close: 'סגירה',
  },
  ar: {
    title: 'الموقع قيد الإنشاء',
    body: 'آلية حجز المحاضرات غير جاهزة بعد. يسعدنا عودتكم قريبًا — في هذه الأثناء يمكنكم التواصل مباشرة عبر البريد amirassi@ono.ac.il',
    close: 'إغلاق',
  },
  en: {
    title: 'This site is still under construction',
    body: 'The lecture booking system is not ready yet. Please check back soon — in the meantime you can reach out directly at amirassi@ono.ac.il',
    close: 'Close',
  },
} as const;

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const UnderConstructionDialog = ({ open, onOpenChange }: Props) => {
  const { lang } = useLanguage();
  const c = TEXT[lang] ?? TEXT.he;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md text-center">
        <DialogHeader className="items-center">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-2">
            <Construction className="w-7 h-7 text-primary" />
          </div>
          <DialogTitle className="text-xl text-gradient-gold">{c.title}</DialogTitle>
          <DialogDescription className="leading-relaxed pt-2">{c.body}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center">
          <Button onClick={() => onOpenChange(false)} className="rounded-full px-8 bg-primary text-primary-foreground hover:bg-primary/90">
            {c.close}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UnderConstructionDialog;
